import React, { useCallback, useEffect, useState } from "react";
import TapSelect from "../../components/ui/TapSelect";
import AssetMiniDetail from "./AssetMiniDetail";
import InputAssetSearch from "./ui/InputAssetSearch";
import InputWorkstationSearch from "./ui/InputWorkstationSearch";
import InputEmployeeSearch from "./ui/InputEmployeeSearch";
import InputSubAssemblySearch from "./ui/InputSubAssemblySearch";
import InputVendorSearch from "./ui/InputVendorSearch";
import InputCustomerSearch from "./ui/InputCustomerSearch";
import { useSelector } from "react-redux";


export default function GeneralSelectFor(props) {
  const { forData } = props;

  const labelClass = props.labelClass || "col-sm-3";
  const inputClass = props.inputClass || "col-sm-4";
  const labelClass2 = props.labelClass2 || "col-sm-4"
  const iam_user_sites = useSelector(
    (state) => state.app?.user_sites || []
  );
  const siteOptions = iam_user_sites.map((site) => ({
    value: site.id,
    label: site.site_name,
    ...site,
  }));
  const forList = [
    { value: "asset", label: "Asset" },
    { value: "workstation", label: "Workstation" },
    { value: "employee", label: "Employee" },
    { value: "sub_assembly", label: "Sub Assembly" },
    { value: "site", label: "Site" },
    { value: "vendor", label: "Vendor" },
    { value: "customer", label: "Customer" },
  ].filter((d) => forData.forField.includes(d.value));

  const [data, setData] = useState({});

  useEffect(() => {
    setData((pre) => ({
      ...pre,
      type: forData.editData?.type || pre.type || "",
      ticketSelected: forData.ticketSelected,
      ...forData.editData,
    }));
  }, [forData.editData, forData.chageWarehouse, forData.ticketSelected]);

  //   useEffect(() => {

  //   setData({
  //     type: forData.editData?.type || "",
  //     ...forData.editData
  //   });
  // }, [forData.editData]);

  //   useEffect(() => {

  //     setData((pre) => ({
  //       ...pre,
  //       type: "",
  //       ticketSelected: forData.ticketSelected,
  //       selected_asset: null,
  //       selected_workstation: null,
  //       selected_employee: null,
  //       selected_subassembly: null,
  //       selected_customer: null,
  //       selected_vendor: null,
  //       workstation_id: "",
  //       asset_id: "",
  //       employee_id: "",
  //       sub_assembly_id: "",
  //       customer_id: "",
  //       vendor_id: "",
  //       ...forData.editData,
  //     }));
  //   }, [forData.chageWarehouse]);

  //   useEffect(() => {
  //     setData((pre) => ({
  //       ...pre,
  //       ticketSelected: forData.ticketSelected,
  //     }));
  //   }, [forData.ticketSelected]);

  // Auto-populate vendor when type is "vendor" and purchase vendor exists
  useEffect(() => {
    if (data.type === "vendor" && forData.purchaseVendor && forData.purchaseVendor.id) {

      const vendorData = {
        value: forData.purchaseVendor.id,
        label: forData.purchaseVendor.name || forData.purchaseVendor.display_label,
        display_label: forData.purchaseVendor.name || forData.purchaseVendor.display_label,
        vendor: forData.purchaseVendor
      };

      setData((pre) => ({
        ...pre,
        selected_vendor: vendorData,
        vendor_id: forData.purchaseVendor.id
      }));

      // Call the callback with auto-populated vendor
      if (props.afterSelectForData) {
        props.afterSelectForData({
          type: "vendor",
          vendor_id: forData.purchaseVendor.id,
          selected_vendor: vendorData
        });
      }
    }
  }, [data.type, forData.purchaseVendor]);

  const handleAfterSelectForData = (type, selectedVal) => {
    let selectData = {};
    switch (type) {
      case "asset":
        selectData = {
          type,
          asset_id: selectedVal ? selectedVal.value : null,
          selected_asset: selectedVal
            ? { ...selectedVal.asset, label: selectedVal.display_label }
            : null,
        };
        break;
      case "workstation":
        selectData = {
          type,
          workstation_id: selectedVal ? selectedVal.value : null,
          selected_workstation: selectedVal ? selectedVal : null,
        };
        break;
      case "employee":
        selectData = {
          type,
          employee_id: selectedVal ? selectedVal.value : null,
          selected_employee: selectedVal ? selectedVal : null,
        };
        break;
      case "sub_assembly":
        selectData = {
          type,
          sub_assembly_id: selectedVal ? selectedVal.value : null,
          selected_subassembly: selectedVal ? selectedVal : null,
        };
        break;
      case "customer":
        selectData = {
          type,
          customer_id: selectedVal ? selectedVal.value : null,
          selected_customer: selectedVal ? selectedVal : null,
        };
        break;
      case "vendor":
        // Only allow manual selection if not auto-populated from purchase
        if (!forData.purchaseVendor) {
          selectData = {
            type,
            vendor_id: selectedVal ? selectedVal.value : null,
            selected_vendor: selectedVal ? selectedVal : null,
          };
        }
        break;
      case "site":
        selectData = {
          type,
          site_id: selectedVal ? selectedVal.value : null,
          selected_site: selectedVal ? selectedVal : null,
        };
        break;
      default:
        return null;
    }

    if (Object.keys(selectData).length > 0) {
      setData((pre) => ({ ...pre, ...selectData }));

      if (props.afterSelectForData) {
        props.afterSelectForData(selectData);
      }
    }
  };

  const handleForSelect = (selectValue) => {
    const newType = selectValue ? selectValue.value : null;

    setData((pre) => ({
      ...pre,
      type: newType,
      selected_asset: null,
      selected_workstation: null,
      selected_employee: null,
      selected_subassembly: null,
      selected_vendor: null,
      selected_customer: null,
      workstation_id: "",
      asset_id: "",
      employee_id: "",
      sub_assembly_id: "",
      vendor_id: "",
      customer_id: "",
      selected_site: null,
      site_id: "",
    }));

    if (!selectValue && props.afterSelectForData) {
      props.afterSelectForData(null);
    }
  };

  // Check if vendor selection should be disabled
  const isVendorDisabled = data.type === "vendor" && forData.purchaseVendor;
  return (
    <>
      <label
        className={`${labelClass} form-label ${forData?.isRequired ? "require" : ""
          }`}
      >
        {forData.type}
      </label>
      <div className={`${inputClass}`}>
        <TapSelect
          placeholder={`Select ${forData.type}`}
          isClearable={true}
          options={forList}
          required={forData?.isRequired}
          value={forList.find((d) => d.value === data.type)}
          changeEvent={(selectValue) => handleForSelect(selectValue)}
          isDisabled={data.ticketSelected}
        />
      </div>
      <div className={`${labelClass2}`}>
        {data.type == "asset" && (
          <>
            <InputAssetSearch
              placeholder="Search Asset"
              filter={true}
              required={true}
              search_site_id={forData.warehouseSites.map((w) => w.id)}
              value={data.selected_asset ? { ...data.selected_asset } : null}
              changeEvent={(selectedVal) => {
                handleAfterSelectForData("asset", selectedVal);
              }}
              disabled={data.ticketSelected}
            />

            {data.selected_asset && (
              <AssetMiniDetail assetDetail={data.selected_asset} />
            )}
          </>
        )}
        {data.type == "workstation" && (
          <>
            <InputWorkstationSearch
              placeholder="Search Workstation"
              menuPlacement="bottom"
              search_site_id={forData.warehouseSites.map((w) => w.id)}
              value={data.selected_workstation}
              changeEvent={(selectedVal) => {
                handleAfterSelectForData("workstation", selectedVal);
              }}
              disabled={data.ticketSelected}
            />
          </>
        )}
        {data.type == "employee" && (
          <>
            <InputEmployeeSearch
              placeholder="Search Employee"
              menuPlacement="bottom"
              search_site_ids={forData.warehouseSites.map((w) => w.id)}
              value={data.selected_employee}
              changeEvent={(selectedVal) => {
                handleAfterSelectForData("employee", selectedVal);
              }}
              disabled={data.ticketSelected}
            />
          </>
        )}
        {data.type == "sub_assembly" && (
          <>
            <InputSubAssemblySearch
              placeholder="Search Sub Assembly"
              menuPlacement="bottom"
              search_site_id={forData.warehouseSites.map((w) => w.id)}
              value={data.selected_subassembly}
              changeEvent={(selectedVal) => {
                handleAfterSelectForData("sub_assembly", selectedVal);
              }}
              disabled={data.ticketSelected}
            />
          </>
        )}
        {data.type == "vendor" && (
          <>
            <InputVendorSearch
              placeholder="Search Vendor"
              menuPlacement="bottom"
              value={data.selected_vendor}
              changeEvent={(selectedVal) => {
                handleAfterSelectForData("vendor", selectedVal);
              }}
              disabled={data.ticketSelected || isVendorDisabled}
              isReadOnly={isVendorDisabled}
            />

          </>
        )}
        {data.type == "customer" && (
          <InputCustomerSearch
            placeholder="Search Customer"
            menuPlacement="bottom"
            search_site_id={forData.warehouseSites.map((w) => w.id)}
            value={data.selected_customer}
            changeEvent={(selectedVal) => {
              handleAfterSelectForData("customer", selectedVal);
            }}
            disabled={data.ticketSelected}
          />
        )}
        {data.type === "site" && (
          <TapSelect
            placeholder="Select Site"
            options={siteOptions}
            value={
              siteOptions.find(
                (site) => site.value === data.site_id
              ) || null
            }
            changeEvent={(selectedVal) => {
              handleAfterSelectForData("site", selectedVal);
            }}
            isClearable={true}
            isSearchable={true}
            isDisabled={data.ticketSelected}
          />
        )}
      </div>
    </>
  );
}
